<template>
	<v-data-table
		:headers="headers"
		:items="list"
		:sort-by="getSortBy()"
		:items-per-page="15"
		:items-per-page-options="[
			{ value: 15, title: '15' },
			{ value: 30, title: '30' },
			{ value: 50, title: '50' },
			{ value: 100, title: '100' },
		]"
		loading-text="Loading... Please wait"
		:loading="loading"
		:hover="true"
		:multi-sort="true"
	>
		<template v-slot:top>
			<div class="d-flex align-center">
				<span class="font-weight-medium">User Managment</span>
				<v-spacer></v-spacer>
				<v-dialog v-model="dialog" max-width="75%">
					<template v-slot:activator="{}">
						<v-btn
							variant="outlined"
							small
							class="blue--text font-weight-bold"
							@click="funEditItem(editItem)"
							>Add User</v-btn
						>
					</template>
					<v-card>
						<v-card-title>
							<span class="text-h5">{{ itemTitle }}</span>
						</v-card-title>

						<v-card-text>
							<v-container>
								<input type="hidden" v-model="editItem.id" />
								<v-text-field
									class="w-auto"
									variant="outlined"
									v-model="editItem.firstName"
									label="First Name"
								></v-text-field>
								<v-text-field
									class="w-auto"
									variant="outlined"
									v-model="editItem.lastName"
									label="Last Name"
								></v-text-field>
								<v-text-field
									class="w-auto"
									variant="outlined"
									v-model="editItem.email"
									label="Email"
									type="email"
									:rules="[email('Email')]"
								></v-text-field>
								<v-autocomplete
									v-model="editItem.accountType"
									:items="accountTypeList"
									item-title="name"
									item-value="id"
									label="Account Type"
									placeholder="Account Type"
									class="w-auto"
									variant="outlined"
								></v-autocomplete>
								<v-text-field
									v-model="editItem.password"
									placeholder="Password"
									name="aNewPass"
									autocomplete="new-password"
									:type="showPass ? 'text' : 'password'"
									:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
									@input="validateForm"
									@click:append="showPass = !showPass"
									:rules="[required('Password'), rules.min]"
									class="w-auto"
									density="compact"
									variant="outlined"
								>
								</v-text-field>
								<v-switch
									class="ma-0 pa-0 form-label"
									density="compact"
									v-model="editItem.useDarkMode"
									label="Use Dark Mode"
								>
								</v-switch>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								outlined
								small
								class="blue--text font-weight-bold"
								@click="changePassword"
								:loading="loading"
								>Change Password</v-btn
							>
							<v-btn
								outlined
								small
								class="blue--text font-weight-bold"
								@click="funSaveItem"
								:loading="loading"
								>Save</v-btn
							>
							<v-btn
								outlined
								small
								class="blue--text font-weight-bold"
								@click="close"
								>Cancel</v-btn
							>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</div>
		</template>
		<template v-slot:[`item.action`]="{ item }">
			<v-icon small class="mr-2" @click="funEditItem(item)"
				>mdi-pencil</v-icon
			>
			<v-icon small @click="funDeleteItem(item)">mdi-delete</v-icon>
		</template>
		<template v-slot:[`item.accountType`]="{ item }">
			<td>{{ formatAcountType(item.accountType) }}</td>
		</template>

		<template v-slot:no-data>
			<span>No Data Available</span>
		</template>
	</v-data-table>
</template>

<script>
import { mapState, mapActions } from "vuex";
import validations from "@/helpers/validations";

import {
	ADD_USER,
	EDIT_USER,
	EDIT_USER_PASSWORD,
	REMOVE_USER,
	LOAD_PROFILES,
} from "@/store/_actiontypes";
import { stringifyQuery } from "vue-router";

export default {
	data: () => ({
		loading: false,
		dialog: false,
		menu: false,
		sortByField: "name",
		showPass: false,
		rules: {
			min: (v) => (v != null && v.length >= 8) || "Min 8 characters",
		},
		showPassword: false,
		...validations,
		accountTypeList: [
			{ id: 0, name: "View" },
			{ id: 1, name: "User" },
			{ id: 2, name: "Admin" },
			{ id: 3, name: "SuperAdmin" },
		],
		headers: [
			{ title: "Id", key: "id", align: " d-none" },
			{ title: "First name", key: "firstName" },
			{ title: "Last name", key: "lastName" },
			{ title: "Account type", key: "accountType" },
			{ title: "Email", key: "email" },
			{ title: "Actions", key: "action", sortable: false, width: 100 },
		],
		editItem: {
			accountType: 0,
			email: "",
			firstName: "",
			fullName: "",
			password: "",
			id: 0,
			lastName: "",
			theme: null,
			useDarkMode: false,
		},
		defaultItem: {
			accountType: 0,
			email: "",
			firstName: "",
			fullName: "",
			password: "",
			id: 0,
			lastName: "",
			theme: null,
			useDarkMode: false,
		},
	}),

	computed: {
		...mapState({ list: (state) => state.account.profilelist }),
		itemTitle() {
			return this.editItem.id === 0 ? "Add User" : "Edit User";
		},
	},
	watch: {
		dialog(val) {
			val || this.close();
		},
	},
	methods: {
		...mapActions("account", [
			ADD_USER,
			EDIT_USER,
			EDIT_USER_PASSWORD,
			REMOVE_USER,
			LOAD_PROFILES,
		]),

		getSortBy() {
			return [this.sortByField];
		},

		funEditItem(item) {
			this.editItem = Object.assign({}, item);
			this.editItem.accountType;
			this.dialog = true;
		},
		loadData() {
			this.loading = true;
			this.LOAD_PROFILES();
			this.loading = false;
		},
		funDeleteItem(item) {
			confirm("Are you sure you want to delete this item?") &&
				this.REMOVE_USER({ id: item.id });
		},

		close() {
			this.dialog = false;
			this.editItem = Object.assign({}, this.defaultItem);
		},

		changePassword() {
			this.loading = true;
			const { email, password } = this.editItem;
			if (password == undefined || password.length < 8) {
				alert("Pasword is less then 8 characters?");
				this.loading = false;
			} else {
				confirm("Are you sure you want to change password?") &&
					this.EDIT_USER_PASSWORD({ email, password })
						.then(() => {
							this.loading = false;
							this.loadData();
							this.close();
						})
						.finally(() => {
							this.loading = false;
						});
			}
			this.loadData();
		},
		funSaveItem() {
			this.loading = true;
			var vItem = this.editItem;
			if (vItem.id == 0) {
				const {
					email,
					firstName,
					lastName,
					password,
					useDarkMode,
					accountType,
				} = this.editItem;

				this.ADD_USER({
					email,
					firstName,
					lastName,
					password,
					useDarkMode,
					accountType,
				})
					.then(() => {
						this.loading = false;
						this.loadData();
						this.close();
					})
					.finally(() => {
						this.loading = false;
						this.loadData();
					});
			} else {
				const {
					id,
					email,
					firstName,
					lastName,
					password,
					useDarkMode,
					accountType,
				} = this.editItem;

				this.EDIT_USER({
					id,
					email,
					firstName,
					lastName,
					password,
					accountType,
					useDarkMode,
				})
					.then(() => {
						this.loading = false;
						this.loadData();
						this.close();
					})
					.finally(() => {
						this.loading = false;
					});
			}
			this.loadData();
		},
		formatAcountType(type) {
			var ret = this.accountTypeList.find((h) => h.id == type);
			return ret.name;
		},
	},

	beforeUnmount() {},
};
</script>

<style></style>
